import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import "./_buildingCreationModal.scss";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import moment from "moment";
import S from "./buildingFinanceStyles";
import { BuildingFormShimmer } from "./buildingShimmer";
import { canEdit } from "../../../utils/modulePermissions";

// /building-creation → "Hostel_Buildings". Match on module_key only.
//
// buildingCreationSection already gates the two openers, the only ways into this modal,
// so this is a backstop on the write itself. It uses the SILENT canEdit() rather than
// requireEdit() because this modal renders no Access Denied modal of its own — the denial
// is surfaced by the gated opener.
const HOSTEL_BUILDINGS_MODULE = ["Hostel_Buildings"];


const ADD_BUILDING_ROOMS_FLOORS_DETAILS = gql`
mutation($params:AddRoomsFloorsDetails){
    addRoomsFloorsDetails(params:$params)
}
`;

// ── Incharge multi-select — same design as the Certificate History dropdown ──
// Trigger button showing a count badge + a "Select All" checkbox panel.
const PURPLE = "#6366f1";
const inchargeMs = {
    trigger: { width: "100%", minHeight: 42, display: "flex", alignItems: "center", gap: 8, background: "#f9fafb", border: "1.5px solid #e5e7eb", borderRadius: 10, padding: "8px 12px", fontSize: 13, cursor: "pointer", transition: "all 0.15s" },
    dropdown: { position: "absolute", left: 0, right: 0, zIndex: 1000, background: "#fff", border: "1.5px solid #e2e8f0", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.12)", overflow: "hidden" },
    checkRow: { display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", cursor: "pointer", margin: 0, width: "100%" },
    checkbox: { width: 16, height: 16, accentColor: PURPLE, cursor: "pointer", flexShrink: 0 },
    checkLabel: { fontSize: 13, userSelect: "none" },
};

function InchargeMultiSelect({ options, selected, onChange, isOpen, onToggleOpen, idKey = "value", labelKey = "label" }) {
    const containerRef = React.useRef(null);
    const [openAbove, setOpenAbove] = React.useState(false);

    React.useEffect(() => {
        if (isOpen && containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            setOpenAbove(spaceAbove > spaceBelow && spaceBelow < 240);
        }
    }, [isOpen]);

    // close when clicking outside the control
    React.useEffect(() => {
        if (!isOpen) return;
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) onToggleOpen();
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [isOpen]);

    const allSelected = options.length > 0 && selected.length === options.length;
    const noneSelected = selected.length === 0;
    const toggleAll = () => onChange(allSelected ? [] : options.map((o) => String(o[idKey])));
    const toggleOne = (id) => {
        const sid = String(id);
        onChange(selected.includes(sid) ? selected.filter((s) => s !== sid) : [...selected, sid]);
    };
    const displayLabel = noneSelected ? "Select Incharge" : (allSelected ? "All Incharges" : `${selected.length} selected`);
    const dropdownPos = openAbove
        ? { bottom: "100%", top: "auto", marginTop: 0, marginBottom: 4 }
        : { top: "100%", bottom: "auto", marginTop: 4, marginBottom: 0 };

    return (
        <div ref={containerRef} style={{ position: "relative", zIndex: isOpen ? 200 : 1 }}>
            <button type="button" onClick={onToggleOpen}
                style={{ ...inchargeMs.trigger, background: isOpen ? "#fff" : "#f9fafb", borderColor: isOpen ? PURPLE : "#e5e7eb", boxShadow: isOpen ? `0 0 0 3px ${PURPLE}22` : "none" }}>
                <span style={{ flex: 1, textAlign: "left", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: noneSelected ? "#9aa3b2" : "#1f2937" }}>{displayLabel}</span>
                {!noneSelected && (
                    <span style={{ background: PURPLE, color: "#fff", borderRadius: "50%", width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{selected.length}</span>
                )}
                <i className={`fal fa-chevron-${isOpen ? "up" : "down"}`} style={{ fontSize: 11, color: "#6b7280", flexShrink: 0 }} />
            </button>
            {isOpen && (
                <div className="incharge-dd-panel" style={{ ...inchargeMs.dropdown, ...dropdownPos }}>
                    {options.length > 0 && (
                        <>
                            <label style={inchargeMs.checkRow}>
                                <input type="checkbox" checked={allSelected} onChange={toggleAll} style={inchargeMs.checkbox} />
                                <span style={{ ...inchargeMs.checkLabel, fontWeight: 700, color: "#374151" }}>Select All</span>
                            </label>
                            <div style={{ height: 1, background: "#e5e7eb", margin: "2px 0" }} />
                        </>
                    )}
                    <div style={{ maxHeight: 200, overflowY: "auto" }}>
                        {options.length === 0
                            ? <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No incharges found</div>
                            : options.map((opt) => {
                                const sid = String(opt[idKey]);
                                const checked = selected.includes(sid);
                                return (
                                    <label key={sid} style={{ ...inchargeMs.checkRow, background: checked ? `${PURPLE}08` : "transparent" }}>
                                        <input type="checkbox" checked={checked} onChange={() => toggleOne(opt[idKey])} style={inchargeMs.checkbox} />
                                        <span style={{ ...inchargeMs.checkLabel, color: checked ? PURPLE : "#374151", fontWeight: checked ? 600 : 400 }}>{opt[labelKey]}</span>
                                    </label>
                                );
                            })
                        }
                    </div>
                </div>
            )}
        </div>
    );
}


class BuildingCreationModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataClear: 1,
            branch_id: "",
            branchError: '',
            buildingName: "",
            buildingNameError: "",
            noOfFloors: "",
            noOfFloorsError: "",
            currentStep: 1,
            floorAndRoomDetails: [],
            getEmployees: [],
            submitError: "",
            displayedFloors: 0,
            deleteId: "",
            hostel_building_id: null,
            existingFloorAndRooms: [],
            editLoading: 0,
            openInchargeIndex: null,
            noChangeMsg: "",


        }
    }

    // Toggle which floor's incharge dropdown is open (only one at a time).
    toggleInchargeOpen = (i) => {
        this.setState((prev) => ({ openInchargeIndex: prev.openInchargeIndex === i ? null : i }));
    };

    // Incharge dropdown returns an array of selected employee-id strings; convert
    // back to the {label, value} objects + CSV id the rest of the code expects.
    handleInchargeSelect = (selectedIds, i) => {
        if (this.state.noChangeMsg) this.setState({ noChangeMsg: "" });
        const selectedIncharges = this.state.getEmployees
            .filter((emp) => selectedIds.includes(String(emp.value)))
            .map((emp) => ({ label: emp.label, value: emp.value }));

        const floorAndRoomDetails = this.state.floorAndRoomDetails.map((item, index) => {
            if (index === i) {
                return {
                    ...item,
                    floor_incharge_id: selectedIncharges.map((e) => e.value).toString(),
                    selected_floor_incharge_details: selectedIncharges,
                    floorInchargeError: "",
                };
            }
            return item;
        });
        this.setState({ floorAndRoomDetails });
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                dataClear: 1,
                branch_id: "",
                branchError: '',
                buildingName: "",
                buildingNameError: "",
                noOfFloors: "",
                noOfFloorsError: "",
                currentStep: 1,
                floorAndRoomDetails: [],
                getEmployees: [],
                submitError: "",
                displayedFloors: 0,
                deleteId: "",
                hostel_building_id: null,
                existingFloorAndRooms: [],
                editLoading: 0,
            })

            if (this.props.stateData.existingBuildingCreationData.length > 0) {
                this.setState({ editLoading: 1 })
                this.loadEditData(this.props.stateData.existingBuildingCreationData);
            }

        }

        if (this.props.show == false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    // Edit prefill: load the incharge options FIRST (await), then build the
    // floor rows and pre-select each floor's saved incharge from that list.
    // (Replaces a setTimeout race that left the dropdown empty when the
    // incharge query resolved after the timeout.)
    loadEditData = async (existingData) => {
        let inchargeOptions = [];
        try {
            inchargeOptions = await this.getEmployess(this.props.stateData.branchSearch) || [];
        } catch (error) {
            console.error("Error fetching incharges:", error);
        }

        let data = [];
        existingData[0].floors_details.forEach((item) => {
            let selectedEmployees = [];
            if (item.floor_incharge_id != null && item.floor_incharge_id !== "") {
                item.floor_incharge_id.toString().split(",").forEach((inchargeId) => {
                    let match = inchargeOptions.filter((emp) => emp.value == inchargeId);
                    selectedEmployees.push(...match);
                });
            }
            data.push({
                ...item,
                capacityOfEachRooms: item.rooms_details[0] ? item.rooms_details[0].room_capacity : "",
                floorNamesError: "",
                noOfRooms: item.rooms_details.length,
                selected_floor_incharge_details: selectedEmployees,
                noOfRoomsError: "",
                roomCapacityError: "",
            });
        });

        this.setState({
            branch_id: this.props.stateData.branchSearch,
            buildingName: existingData[0].hostel_building_name,
            noOfFloors: existingData[0].floors_details.length,
            hostel_building_id: existingData[0].hostel_building_id,
            floorAndRoomDetails: data,
            existingFloorAndRooms: data,
            editLoading: 0,
        });
    };

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;

        let getArray = [];
        if (name == "branch") {

            if (value != "0") {
                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branch_id: value,
                    branchError: '',
                    buildingName: "",
                    buildingNameError: "",
                    noOfFloors: "",
                    noOfFloorsError: "",
                    floorAndRoomDetails: [],
                });

                this.getEmployess(value);

            } else {
                this.setState({
                    branch_id: '',
                    branchError: '',
                    buildingName: "",
                    noOfFloors: "",
                    buildingName: "",
                    buildingNameError: "",
                    noOfFloors: "",
                    noOfFloorsError: "",
                    floorAndRoomDetails: [],

                })
            }
        }

    };

    getEmployess = async (val) => {

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int){
                getHostelIncharges(institute_id:$institute_id,branch_id:$branch_id){
                  employee_id
                  employee_name
                  employee_role
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        })

        let data = [];
        const incharges = result.data.getHostelIncharges || [];
        if (incharges.length > 0) {
            // Incharges = employees of this institute/branch whose role is an
            // "incharge" role (resolved on the backend via employee_role).
            incharges.map((item) => {
                let obj = {
                    label: item.employee_name,
                    value: item.employee_id,
                    role: item.employee_role,
                }
                data.push(obj)
            })
        }
        this.setState({
            getEmployees: data,
        })

        return data
    };

    selecthandleInputChange = (e, i) => {
        let name = e.target.name;
        let value = e.target.value;
        if (this.state.noChangeMsg) this.setState({ noChangeMsg: "" });

        console.log("cccccc", name, value);

        if (name == "buildingName") {
            this.setState({
                buildingNameError: "",
                buildingName: value,
            })
        }

        if (name == "noOfFloors") {
            if (value <= 30) {
                let array = Array.from({ length: value }, (_, item) => {
                    return { hostel_building_floor_id: null, floor_name: `Floor ${item + 1}`, noOfRooms: "", capacityOfEachRooms: "", rooms_details: [], floor_incharge_id: "", noOfRoomsError: "", selected_floor_incharge_details: [], floorNamesError: "", floorInchargeError: "" }
                })
                this.setState({
                    floorAndRoomDetails: array,
                    noOfFloorsError: "",
                    noOfFloors: value
                })
            } else {
                this.setState({
                    floorAndRoomDetails: [],
                    noOfFloorsError: "",
                    noOfFloors: ""
                })
            }
        }

        if (name == "floor_name") {
            console.log("floor", this.state.floorAndRoomDetails, i);

            let floorData = [];

            this.state.floorAndRoomDetails.map((item, index) => {
                if (index == i) {
                    floorData.push({ ...item, floor_name: value, floorNamesError: "" })
                } else {
                    floorData.push({ ...item })
                }
            })

            this.setState({
                floorAndRoomDetails: floorData,
                room_capacity: "",
                room_name: "",
                rooms_details: [],
                floorNamesError: "",
            })
        }

        if (name == "noOfRooms") {
            console.log("rooms", this.state.floorAndRoomDetails, i, name, value);
            if (value != "0" && value != "" && value <= 20) {
                let floorData = [];
                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        floorData.push({ ...item, noOfRooms: value, noOfRoomsError: "", rooms_details: [], capacityOfEachRooms: "" })
                    } else {
                        floorData.push({ ...item })
                    }
                })
                this.setState({
                    floorAndRoomDetails: floorData,
                })

            } else {
                let floorData = [];
                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        floorData.push({ ...item, noOfRooms: "", rooms_details: [], capacityOfEachRooms: "" })
                    } else {
                        floorData.push({ ...item })
                    }
                })
                this.setState({
                    floorAndRoomDetails: floorData
                })
            }

        }

        if (name == "capacityOfEachRooms") {

            if (value != "0" && value != "") {

                let floorData = [];
                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        let array = Array.from({ length: item.noOfRooms }, (_, item) => {
                            let roomName = "";

                            if (item + 1 > 9) {
                                roomName = `${i + 1}${item + 1}`
                            } else {
                                roomName = `${i + 1}0${item + 1}`
                            }

                            return { room_id: null, room_name: roomName, room_capacity: value, roomNamesError: "", roomEachCapacityError: "" }
                        })

                        floorData.push({ ...item, capacityOfEachRooms: value, roomCapacityError: "", rooms_details: array })
                    } else {
                        floorData.push({ ...item })
                    }
                })

                this.setState({
                    floorAndRoomDetails: floorData,
                    floorNamesError: "",
                })
            } else {
                let floorData = [];
                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        floorData.push({ ...item, capacityOfEachRooms: "", rooms_details: [], roomCapacityError: "" })
                    } else {
                        floorData.push({ ...item })
                    }
                })

                this.setState({
                    floorAndRoomDetails: floorData,
                })
            }
        }

        if (name == "room_name") {
            console.log("roomsoooooo", this.state.floorAndRoomDetails, i, name, value);

            let array = [];

            this.state.floorAndRoomDetails.map((item, index) => {
                if (index == this.state.displayedFloors) {

                    console.log("item", item);
                    let roomsData = [];

                    item.rooms_details.map((item1, index) => {
                        if (index === i) {
                            roomsData.push({ ...item1, room_name: value, roomNamesError: "", roomEachCapacityError: "" })
                        } else {
                            roomsData.push({ ...item1 })
                        }
                    })
                    array.push({ ...item, rooms_details: roomsData })

                } else {
                    array.push({ ...item })
                }
            })

            console.log("array", array);

            this.setState({ floorAndRoomDetails: array })



        }

        if (name == "room_capacity") {
            let array = [];

            this.state.floorAndRoomDetails.map((item, index) => {
                if (index == this.state.displayedFloors) {

                    console.log("item", item);
                    let roomsData = [];

                    item.rooms_details.map((item1, index) => {
                        if (index === i) {
                            roomsData.push({ ...item1, room_capacity: parseInt(value), roomEachCapacityError: "" })
                        } else {
                            roomsData.push({ ...item1 })
                        }
                    })
                    array.push({ ...item, rooms_details: roomsData })

                } else {
                    array.push({ ...item })
                }
            })
            this.setState({ floorAndRoomDetails: array })

        }

    }

    // Normalize floors/rooms to only the meaningful, comparable fields so we can
    // detect whether anything actually changed in edit mode.
    normalizeFloors = (floors) =>
        (floors || []).map((f) => ({
            floor_name: (f.floor_name || "").toString().trim(),
            floor_incharge_id: (f.floor_incharge_id || "").toString(),
            rooms: (f.rooms_details || []).map((r) => ({
                name: (r.room_name || "").toString().trim(),
                cap: (r.room_capacity === undefined || r.room_capacity === null ? "" : r.room_capacity).toString(),
            })),
        }));

    hasEditChanges = () => {
        const originalName = (
            (this.props.stateData.existingBuildingCreationData[0] &&
                this.props.stateData.existingBuildingCreationData[0].hostel_building_name) || ""
        ).toString().trim();
        const currentName = (this.state.buildingName || "").toString().trim();
        if (originalName !== currentName) return true;

        return (
            JSON.stringify(this.normalizeFloors(this.state.existingFloorAndRooms)) !==
            JSON.stringify(this.normalizeFloors(this.state.floorAndRoomDetails))
        );
    };

    getDisplayData = () => {
        this.setState({ noChangeMsg: "" });

        if (this.state.branch_id == "") {
            this.setState({ branchError: 'Please select branch', });
            return true
        }

        if (this.state.buildingName == "") {
            this.setState({ buildingNameError: "Please Enter Building Name" })
            return true
        }

        // Edit mode: if nothing changed, don't submit — just inform the user.
        if (this.state.existingFloorAndRooms.length > 0 && !this.hasEditChanges()) {
            this.setState({ noChangeMsg: "No changes to update." });
            return "";
        }


        let isError = false;

        this.state.floorAndRoomDetails.some((obj, i) => {
            let errorDetails = this.state.floorAndRoomDetails;
            console.log("errrr", errorDetails);


            if (obj.floor_name == "" || obj.floor_name == undefined) {
                errorDetails[i] = { ...obj, floorNamesError: "Please Enter Floor Name" }
                console.log("ggagga", errorDetails);
                this.setState({ floorAndRoomDetails: errorDetails })
                isError = true;
                return true
            }

            // Floor incharge is optional — no validation here.

            if (obj.noOfRooms == "" || obj.noOfRooms == undefined) {
                errorDetails[i] = { ...obj, noOfRoomsError: "Please Enter Number Of Rooms" }
                this.setState({ floorAndRoomDetails: errorDetails })
                isError = true;
                return true
            }


            if (obj.capacityOfEachRooms == "" || obj.capacityOfEachRooms == undefined) {
                errorDetails[i] = { ...obj, roomCapacityError: "Please Enter Room Capacity" }
                this.setState({ floorAndRoomDetails: errorDetails })
                isError = true;
                return true
            }

            let rooms_details = obj.rooms_details;
            obj.rooms_details.map((item, index) => {

                console.log("item", item);
                if (item.room_name == "" || item.room_name == undefined) {
                    rooms_details[index] = { ...item, roomNamesError: "Plase Enter Room Name" }
                    errorDetails[i] = { ...obj, rooms_details: rooms_details }
                    this.setState({ floorAndRoomDetails: errorDetails })
                    isError = true;
                    return true
                }

                if (item.room_capacity == "" || item.room_capacity == undefined) {
                    rooms_details[index] = { ...item, roomEachCapacityError: "Plase Enter room capacity" }
                    errorDetails[i] = { ...obj, rooms_details: rooms_details }
                    this.setState({ floorAndRoomDetails: errorDetails })
                    isError = true;
                    return true
                }

            })
        })

        if (isError == true) {
            return ""
        }


        let floorDetails = [];

        this.state.floorAndRoomDetails.map((item) => {

            console.log("item", item);
            let roomData = [];

            item.rooms_details.map((item2) => {
                roomData.push({ room_id: parseInt(item2.room_id), room_capacity: parseInt(item2.room_capacity), room_name: item2.room_name.toString() })
            });

            floorDetails.push({ hostel_building_floor_id: parseInt(item.hostel_building_floor_id), floor_name: item.floor_name.toString(), floor_incharge_id: item.floor_incharge_id, rooms_details: roomData })
        })

        console.log("params", floorDetails);

        const params = {
            branch_id: parseInt(this.state.branch_id),
            institute_id: parseInt(Cookies.get("institutionid")),
            hostel_building_name: this.state.buildingName,
            hostel_building_id: this.state.hostel_building_id,
            inserted_by: parseInt(Cookies.get("id")),
            floors_details: floorDetails,
        }

        this.setState({ loadingSpinner: 1 })

        console.log("params", params);

        // return ""


        this.addRoomsFloorsDetails(params).catch(error => {
            // Keep the modal open and show the error instead of reloading the page.
            this.setState({
                submitError: error.graphQLErrors ? error.graphQLErrors.map(x => x.message).join(", ") : error.message,
                loadingSpinner: 0,
            });
        });
    };





    // Last gate before addRoomsFloorsDetails (create/update building + floors + rooms)
    // leaves the client.
    addRoomsFloorsDetails = async params => {
        if (!canEdit(HOSTEL_BUILDINGS_MODULE)) return;

        await this.props.addRoomsFloorsDetails({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("data777", data);
                if (data.addRoomsFloorsDetails) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.props.onHide();
                        // Refresh the building list in place (for the branch we just
                        // saved into) instead of reloading the whole page.
                        if (this.props.onSaved) this.props.onSaved(this.state.branch_id);
                    }, 1500);
                }

            }
        })
    }

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    handleMultipleSelectInputChange = (e, name, i) => {

        console.log("handleMultipleSelectInputChange", e, name, i);

        if (name == "incharges") {
            let selectedIncharges = [];
            let selectedInchargesValues = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const incharges = e[i];
                    const newObj = {
                        label: incharges.label,
                        value: incharges.value
                    }
                    selectedIncharges.push(newObj);
                    selectedInchargesValues.push(newObj.value);
                }

                let floorAndRoomDetails = [];

                this.state.floorAndRoomDetails.map((item, index) => {
                    if (index == i) {
                        floorAndRoomDetails.push({ ...item, floor_incharge_id: selectedInchargesValues.toString(), selected_floor_incharge_details: selectedIncharges, floorInchargeError: "" })
                    } else {
                        floorAndRoomDetails.push({ ...item, floorInchargeError: "" })
                    }
                })

                this.setState({ floorAndRoomDetails: floorAndRoomDetails })
                console.log("dddd", selectedIncharges, selectedInchargesValues.toString());
            }
        }
    }

    toggleDisplayedFloor = (e, floorId) => {
        e.preventDefault();
        this.setState({
            displayedFloors: floorId
        })
    };


    deleteRoom = (e, val, data) => {
        console.log("data", data, val);
        if (window.confirm("Are you sure you want delete room ?")) {
            let data = [];
            this.state.floorAndRoomDetails.map((item, index) => {
                if (index == this.state.displayedFloors) {
                    let roomsData = item.rooms_details.filter((item1, index1) => index1 != val)
                    data.push({ ...item, rooms_details: roomsData, noOfRooms: item.noOfRooms - 1 })
                } else {
                    data.push({ ...item })
                }
            });
            this.setState({ floorAndRoomDetails: data })
        }
    }

    deleteFloor = (val) => {
        if (window.confirm("Are you sure you want delete floor ?")) {
            let data = this.state.floorAndRoomDetails.filter((item, index) => index != val)
            this.setState({ floorAndRoomDetails: data, noOfFloors: data.length })
        }
    }

    addRoom = () => {

        let newData = [{ hostel_building_floor_id: null, floor_name: `Floor ${this.state.floorAndRoomDetails.length + 1}`, noOfRooms: "", capacityOfEachRooms: "", rooms_details: [], floor_incharge_id: "", noOfRoomsError: "", selected_floor_incharge_details: [], floorNamesError: "", floorInchargeError: "" }]
        let newRoomData = [...this.state.floorAndRoomDetails, ...newData];
        this.setState({ floorAndRoomDetails: newRoomData, noOfFloors: this.state.noOfFloors + 1 })
    }

    render() {



        console.log("maheshprops", this.props);
        console.log("maheshstate", this.state);

        const { floorAndRoomDetails, displayedFloors } = this.state;


        let floorInchargeSelectAll = true;
        let inchargelabelledby = "Select";
        let inchargedisablesearch = false;

        if (this.state.getEmployees.length > 0) {
            floorInchargeSelectAll = true;
            inchargedisablesearch = false;
        } else {
            inchargedisablesearch = true;
            floorInchargeSelectAll = false;
            inchargelabelledby = "incharge";
        }

        let roomData = [];
        if (this.state.floorAndRoomDetails != undefined) {
            roomData = this.state?.floorAndRoomDetails?.filter((item, index) => index == this.state.displayedFloors);
        }
        console.log("roomData", roomData);

        return (
            <Modal
                {...this.props}
                className="bc-modal"
                size="lg"
                aria-labelledby="contained-modal-title-venter"
            >
                <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)" }}>
                    <Modal.Header style={{ background: "#fff", borderBottom: "1px solid #f1f5f9", padding: "18px 24px" }}>
                        <Modal.Title style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", margin: 0 }}>
                            <span style={S.iconWrapperCreate}><i className="fal fa-building" /></span>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", lineHeight: 1.2 }}>
                                    {this.state.existingFloorAndRooms.length > 0 ? "Edit Building" : "Create New Building"}
                                </span>
                                <span style={{ fontSize: 12, fontWeight: 500, color: "#64748b", marginTop: 2 }}>
                                    {this.state.existingFloorAndRooms.length > 0
                                        ? "Update floors, rooms and capacity details"
                                        : "Add building with floors, rooms and capacity"}
                                </span>
                            </div>
                            <button type="button" aria-label="Close" onClick={this.props.onHide} style={S.modalClose}>&times;</button>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: "24px" }}>
                        <div style={S.modalCard}>
                            {this.state.editLoading == 1 && (
                                <div style={{ ...S.loadingOverlay, background: "#fff", alignItems: "stretch", justifyContent: "flex-start", padding: "20px 22px", overflowY: "auto" }}>
                                    <BuildingFormShimmer rows={3} />
                                </div>
                            )}
                            <Form onSubmit={(e) => e.preventDefault()}>
                                <div style={S.formSection}>
                                    <div style={S.modalSectionHead}>
                                        <span style={S.stepBadge}>1</span> Building Details
                                    </div>
                                    <Row>
                                        <Col lg={4} md={12} sm={12} className="mb-3">
                                            <label style={S.label}>Branch <span style={{ color: "#ef4444" }}>*</span></label>
                                            <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch_id} isInvalid={this.state.branchError} disabled={this.state.existingFloorAndRooms.length > 0 ? true : false}>
                                                <option value={""}>--Select Branch--</option>
                                                {[...this.props.globals.globalBranches].sort((a, b) => b.id - a.id).map(branchdata => (
                                                    <option key={branchdata.id} value={branchdata.id} >
                                                        {branchdata.branch_name}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                            {this.state.branchError && <div style={S.errText}>{this.state.branchError}</div>}
                                        </Col>

                                        <Col lg={4} md={12} sm={12} className="mb-3">
                                            <label style={S.label}>Building Name <span style={{ color: "#ef4444" }}>*</span></label>
                                            <Form.Control type="text" placeholder="Enter Building Name" name='buildingName' onChange={(e) => { this.selecthandleInputChange(e) }} value={this.state.buildingName} />
                                            {this.state.buildingNameError && <div style={S.errText}>{this.state.buildingNameError}</div>}
                                        </Col>

                                        <Col lg={4} md={12} sm={12} className="mb-3">
                                            <label style={S.label}>No. Of Floors</label>
                                            <Form.Control type="number" placeholder="Enter No.Of Floors" name='noOfFloors' onChange={(e) => { this.selecthandleInputChange(e) }} value={this.state.noOfFloors} disabled={this.state.existingFloorAndRooms.length > 0 ? true : false} />
                                            {this.state.noOfFloorsError && <div style={S.errText}>{this.state.noOfFloorsError}</div>}
                                        </Col>
                                    </Row>
                                </div>

                                {this.state.floorAndRoomDetails.length > 0 && (
                                    <div style={S.modalSectionHead}>
                                        <span style={S.stepBadge}>2</span> Floors &amp; Incharge
                                    </div>
                                )}

                                {
                                    this.state.floorAndRoomDetails.length > 0 ? (
                                        this.state.floorAndRoomDetails.map((item, i) => {
                                            return (
                                                <div style={S.floorCard} key={i}>
                                                    <div style={S.floorCardHead}>
                                                        <span style={S.stepBadge}>{i + 1}</span>
                                                        <span><i className="fal fa-layer-group mr-1" />{item.floor_name || `Floor ${i + 1}`}</span>
                                                        {
                                                            this.state.existingFloorAndRooms.length > 0 ? (
                                                                <Button type="button" variant="link" name="delete" className="text-danger p-0" title="Delete floor" style={{ marginLeft: "auto", lineHeight: 1 }} onClick={(e) => { e.preventDefault(); this.deleteFloor(i) }}><i className="far fa-trash-alt" /></Button>
                                                            ) : ("")
                                                        }
                                                    </div>

                                                    <Row className="align-items-start" style={{ marginLeft: 0, marginRight: 0 }}>
                                                        <Col lg={3} md={6} sm={12} className="mb-2 mb-lg-0 px-1">
                                                            <label style={S.fieldLabel}>Floor Name</label>
                                                            <Form.Control type="text" placeholder="Floor name" name='floor_name' onChange={(e) => { this.selecthandleInputChange(e, i) }} value={item.floor_name} />
                                                            {item.floorNamesError && <div style={S.errText}>{item.floorNamesError}</div>}
                                                        </Col>

                                                        <Col lg={4} md={6} sm={12} className="mb-2 mb-lg-0 px-1">
                                                            <label style={S.fieldLabel}>Incharge Name</label>
                                                            <InchargeMultiSelect
                                                                options={this.state.getEmployees}
                                                                selected={(item.selected_floor_incharge_details || []).map((d) => String(d.value))}
                                                                onChange={(ids) => this.handleInchargeSelect(ids, i)}
                                                                isOpen={this.state.openInchargeIndex === i}
                                                                onToggleOpen={() => this.toggleInchargeOpen(i)}
                                                                idKey="value"
                                                                labelKey="label"
                                                            />
                                                            {item.floorInchargeError && <div style={S.errText}>{item.floorInchargeError}</div>}
                                                        </Col>

                                                        <Col lg={2} md={6} sm={12} className="mb-2 mb-lg-0 px-1">
                                                            <label style={S.fieldLabel}>No. Of Rooms</label>
                                                            <Form.Control type="number" placeholder="e.g. 10" name='noOfRooms' onChange={(e) => { this.selecthandleInputChange(e, i) }} value={item.noOfRooms} disabled={item.hostel_building_floor_id != null || item.floor_name == "" ? true : false} />
                                                            {item.noOfRoomsError && <div style={S.errText}>{item.noOfRoomsError}</div>}
                                                        </Col>

                                                        <Col lg={3} md={6} sm={12} className="mb-2 mb-lg-0 px-1">
                                                            <label style={S.fieldLabel}>Room Capacity</label>
                                                            <Form.Control type="number" placeholder="e.g. 4" name='capacityOfEachRooms' onChange={(e) => { this.selecthandleInputChange(e, i) }} value={item.capacityOfEachRooms} disabled={item.hostel_building_floor_id != null || item.noOfRooms == "" ? true : false} />
                                                            {item.roomCapacityError && <div style={S.errText}>{item.roomCapacityError}</div>}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                        })
                                    ) : ("")
                                }
                            </Form>


                            {
                                this.state.existingFloorAndRooms.length > 0 ? (
                                    <div className="d-flex justify-content-center mt-3">
                                        <Button className="mb-2" style={{ background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)", border: "none", borderRadius: 10, fontWeight: 600, boxShadow: "0 4px 12px rgba(217,119,6,0.25)" }} onClick={this.addRoom}>
                                            <i className="fal fa-plus mr-2" />Add Floor</Button>
                                    </div>
                                ) : ("")
                            }

                            {
                                floorAndRoomDetails.length > 0 ? (
                                    <div style={{ marginTop: 18, paddingTop: 18, borderTop: "1px dashed #e2e8f0" }}>
                                        <div style={S.modalSectionHead}>
                                            <span style={S.stepBadge}>3</span> Configure Rooms
                                            <span style={{ fontWeight: 500, fontSize: 11, color: "#94a3b8", textTransform: "none", letterSpacing: 0 }}>— select a floor below to edit its rooms</span>
                                        </div>
                                        <Row className="BuildingCreation mt-2" style={{ marginLeft: 0, marginRight: 0 }}>
                                            {floorAndRoomDetails.map((floorDetails, index) => {
                                                return (
                                                    <Col lg={2} md={3} sm={4} xs={6} className="px-1" key={index}>

                                                        <button className={this.state.displayedFloors == index ? "active block_view" : "block_view"}
                                                            onClick={(e) => this.toggleDisplayedFloor(e, index)}
                                                            style={{
                                                                textAlign: "center",
                                                                width: "100%",
                                                                marginBottom: "8px",
                                                                padding: "4px 6px",
                                                                fontWeight: 600,
                                                                fontSize: 11,
                                                                border: this.state.displayedFloors == index ? "1.5px solid #6366f1" : "1.5px solid #e5e7eb",
                                                                color: this.state.displayedFloors == index ? "#4f46e5" : "#475569",
                                                                backgroundColor: this.state.displayedFloors == index ? "#eef2ff" : "#fff",
                                                                borderRadius: "7px",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            {floorDetails.floor_name && floorDetails.floor_name.trim() ? floorDetails.floor_name : `Floor ${index + 1}`}
                                                        </button>

                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    </div>
                                ) : ("")
                            }

                            <Row style={{ marginLeft: 0, marginRight: 0 }}>
                                {
                                    roomData.length > 0 ? (
                                        roomData[0]?.rooms_details.length > 0 ? (
                                            roomData[0].rooms_details.map((item, index) => (
                                                <Col lg={3} md={4} sm={6} xs={12} className="mb-2 px-1" key={index}>
                                                    <div style={S.roomBox}>
                                                        <div style={S.roomBoxHead}>
                                                            <i className="fal fa-door-open mr-1" /> Room {index + 1}
                                                            {
                                                                this.state.existingFloorAndRooms.length > 0 ? (
                                                                    <Button variant="link" name="delete" className="text-danger p-0" style={{ marginLeft: "auto", lineHeight: 1 }} onClick={(e) => { this.deleteRoom(item, index, roomData) }}><i className="far fa-trash-alt" /></Button>
                                                                ) : ("")
                                                            }
                                                        </div>
                                                        <div className="d-flex" style={{ gap: 10 }}>
                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                <label style={S.roomFieldLabel}>Room No</label>
                                                                <input type="text" name="room_name" style={S.roomInput} placeholder="No"
                                                                    onChange={(e) => { this.selecthandleInputChange(e, index) }}
                                                                    value={item.room_name}
                                                                />
                                                                {item.roomNamesError && <div style={S.errText}>{item.roomNamesError}</div>}
                                                            </div>
                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                <label style={S.roomFieldLabel}>Capacity</label>
                                                                <input type="number" name="room_capacity" style={S.roomInput} placeholder="Capacity"
                                                                    onChange={(e) => { this.selecthandleInputChange(e, index) }}
                                                                    value={item.room_capacity}
                                                                    disabled={item.room_name !== "" ? false : true}
                                                                />
                                                                {item.roomEachCapacityError && <div style={S.errText}>{item.roomEachCapacityError}</div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))

                                        ) : ("")


                                    ) : ("")
                                }

                            </Row>

                            {
                                this.state.floorAndRoomDetails.length > 0 ? (
                                    <div className="d-flex flex-column align-items-center mt-3">
                                        <Button style={{ ...S.submitBtn, width: "auto" }} onClick={(e) => this.getDisplayData()} type="submit">
                                            {
                                                this.state.loadingSpinner == 1 ? (
                                                    <span className="spinner-border spinner-border-sm mr-2"></span>
                                                ) : ""
                                            }
                                            {this.state.existingFloorAndRooms.length > 0 ? "Update Building" : "Submit"}</Button>

                                        <div className='d-block'>
                                            {this.state.currentStep == 5 ? (
                                                <Form.Text className="form-text" style={{ textAlign: "center" }}>
                                                    <p style={{ color: "#059669" }}>{this.state.existingFloorAndRooms.length > 0 ? "Building updated successfully" : "Building created successfully"}</p>
                                                </Form.Text>
                                            ) : (
                                                <Form.Text className="form-text text-danger" style={{ textAlign: "center", display: this.state.submitError ? "block" : "none" }}>
                                                    {this.state.submitError}
                                                </Form.Text>
                                            )}
                                            {this.state.noChangeMsg ? (
                                                <div style={{ marginTop: 8, textAlign: "center", color: "#b45309", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "6px 14px", fontSize: 13, fontWeight: 600, display: "inline-block" }}>
                                                    <i className="fal fa-info-circle mr-2" />{this.state.noChangeMsg}
                                                </div>
                                            ) : ("")}
                                        </div>
                                    </div>

                                ) : null
                            }
                        </div>

                    </Modal.Body>
                </div>
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(ADD_BUILDING_ROOMS_FLOORS_DETAILS, {
        name: "addRoomsFloorsDetails"
    }),
)(BuildingCreationModal))
);